import { createContext } from 'react';

import { type CustomerContext as CustomerContextType } from '../types';

const CustomerContext = createContext<CustomerContextType>({
    customerInfo: null,
    isLoggedIn: false,
    isNewCustomer: false,
    hasFetched: false,
});

export { CustomerContext };
